exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Version_wrapper__1Y10o{padding:20px 0;background-color:#f6f6f6;color:#9fa0a4}.Version_wrapper__1Y10o .container{margin-bottom:0}@media only screen and (max-width:960px){.Version_wrapper__1Y10o{padding-bottom:30px}}.Version_content__26h-a{margin:0 auto;font-size:12px;line-height:15px;text-align:right}.Version_content__26h-a .Version_contentHeading__JT8U-{margin-bottom:1rem;margin-bottom:10px;font-weight:700;font-size:12px;color:#626469}.Version_content__26h-a .Version_contentText__q8leY{margin-bottom:0}@media only screen and (max-width:960px){.Version_content__26h-a{padding:0 15px}}", ""]);

// exports
exports.locals = {
	"wrapper": "Version_wrapper__1Y10o",
	"content": "Version_content__26h-a",
	"contentHeading": "Version_contentHeading__JT8U-",
	"contentText": "Version_contentText__q8leY"
};